import React from 'react';
import moment from 'moment';

import DatePickerInput from 'components/form/DatePickerInput.component';

import BackButton from 'booking/components/common/bw-header/BackButton';
import HeaderWrapper from 'booking/components/common/bw-header/HeaderWrapper';
import BWContent from 'booking/components/common/BWContent';
import BWFooter from 'booking/components/common/BWFooter';
import PageTitle from 'booking/components/common/PageTitle';
import TextField from 'booking/components/common/TextField';

export class EditPatchNotes extends React.Component {
  constructor(props) {
    super(props);
    const date = props.client.patch_test_date ? props.client.patch_test_date : moment();
    this.state = {
      patchProps: {
        patch_test_notes: props.client.patch_test_notes ? props.client.patch_test_notes : '',
        patch_test_date: date,
        patch_test_stylist_text: props.client.patch_test_stylist_text ? props.client.patch_test_stylist_text : '',
      },
      timePickerModal: false,
      startedFetch: false,
    };
  }

  // noinspection JSCheckFunctionSignatures
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.state.startedFetch && !nextProps.isFetching) {
      this.props.goBackClientProfile();
    }
  }

  onSave = () => {
    if (!this.props.isFetching) {
      const client = {};
      client.patch_test_date = this.state.patchProps.patch_test_date;
      client.patch_test_stylist_text = this.state.patchProps.patch_test_stylist_text;
      client.patch_test_notes = this.state.patchProps.patch_test_notes;
      client.id = this.props.client.id;
      client.email = this.props.client.email;
      client.phone = this.props.client.phone;
      client.salon_id = this.props.client.salon_id;
      client.email = this.props.client.email;
      client.phone = this.props.client.phone;
      this.props.saveClient(
        {
          ...client,
        },
        true,
      );
      this.setState({ startedFetch: true });
    }
  };

  onTimeChange = (time) => {
    const patchProps = Object.assign({}, this.state.patchProps);
    patchProps.patch_test_date = time.toISOString();
    this.setState({ patchProps, timePickerModal: false });
  };

  render() {
    return (
      <div data-bem="EditPatchNotes">
        <div className="BookingWindow">
          <HeaderWrapper>
            <BackButton onClick={this.props.goBackClientProfile} />
            <PageTitle pageTitle="Patch Test" subTitle="" />
          </HeaderWrapper>
          <BWContent additionalClass="space">
            <div className="patch-test-container">
              <div className={`day-select patch-date-picker ${this.state.timePickerModal ? '' : 'hidden'}`}>
                <DatePickerInput
                  tag="EditPatchNotes__test-date"
                  component={DatePickerInput.CommonDatePicker}
                  inline
                  selected={moment(this.state.patchProps.patch_test_date)}
                  isShowing={this.state.timePickerModal}
                  locale="en-GB"
                  onOutsideClick={() => void this.setState({ timePickerModal: false })}
                  onChange={(newDate) => void this.onTimeChange(newDate)}
                />
              </div>

              <TextField labelName="Test Date" htmlFor="name">
                <input
                  id="name"
                  className="input-default"
                  type="text"
                  readOnly
                  onClick={() => {
                    this.setState({ timePickerModal: true });
                  }}
                  value={moment(this.state.patchProps.patch_test_date).format('LL')}
                />
              </TextField>

              <TextField labelName="Stylist" htmlFor="stylist_name">
                <input
                  id="stylist-name"
                  className="input-default"
                  type="text"
                  onChange={(e) => {
                    const patchProps = Object.assign({}, this.state.patchProps);
                    patchProps.patch_test_stylist_text = e.target.value;
                    this.setState({ patchProps });
                  }}
                  value={this.state.patchProps.patch_test_stylist_text}
                />
              </TextField>
              <div className="patch-test-notes">
                <TextField labelName="Patch Test Notes" htmlFor="notes">
                  <textarea
                    style={{ resize: 'vertical' }}
                    onChange={(e) => {
                      const patchProps = Object.assign({}, this.state.patchProps);
                      patchProps.patch_test_notes = e.target.value;
                      this.setState({ patchProps });
                    }}
                    value={this.state.patchProps.patch_test_notes}
                    placeholder=""
                  />
                </TextField>
              </div>
            </div>
          </BWContent>
          <BWFooter additionalClass="wide-footer sticky-bottom border-t">
            {this.props.isFetching && (
              <button className="btn  btn-violet disabled pull-right" onClick={this.onSave}>
                Saving...
              </button>
            )}

            {!this.props.isFetching && (
              <button className="btn  btn-violet pull-right" onClick={this.onSave}>
                Save
              </button>
            )}
          </BWFooter>
        </div>
      </div>
    );
  }
}

export default EditPatchNotes;
